import authService from './authService';
import { readData } from './apiResponse';
import type { AppSettings } from '../types/planning';

/** Administração → Configurações (só admin): liberação geral do Acervo CAC. */
class SettingsService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /admin/settings */
  async get(): Promise<AppSettings> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/admin/settings');
    return readData<AppSettings>(response, 'Falha ao carregar as configurações');
  }

  /** PUT /admin/settings { cac_enabled_for_all } */
  async update(cacEnabledForAll: boolean): Promise<AppSettings> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.put('/admin/settings', { cac_enabled_for_all: cacEnabledForAll });
    return readData<AppSettings>(response, 'Falha ao salvar as configurações');
  }
}

export const settingsService = new SettingsService();
export default settingsService;
